import axios from 'axios';

// Adiciona um interceptor de requisição
axios.interceptors.request.use(
  (config) => {
    // Adiciona o token de autorização aos cabeçalhos da requisição
    config.headers.Authorization = localStorage.getItem('token');
    return config;
  },
  (error) => Promise.reject(error),
);

// Adiciona um interceptor de resposta
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Redirected to login by 401.');
      // Redireciona para a página de login se não estiver nela
      if (window.location.pathname !== '/login') window.location.pathname = '/';
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  },
);

export default axios;
